import { Card } from 'entities/card/model/types';
import { api } from 'shared/api';
import { ApiResponse } from 'shared/model/types';

const _api = api.injectEndpoints({
  endpoints: (build) => ({
    change3ds: build.mutation<
      ApiResponse<Card>,
      {
        email: string;
        phone: string;
        password: string;
        accountId: string;
        cardId: string;
      }
    >({
      query: ({ accountId, cardId, email, phone, password }) => ({
        url: `/private/river/${accountId}/card/${cardId}/update-3d-parameters`,
        method: 'POST',
        body: { email, mobile: phone, password },
      })
    })
  })
});

export const { useChange3dsMutation } = _api;